import React, { useContext } from "react"
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"
import { isMobileContext } from "../context/isMobileContext"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/pagination"
import { Navigation } from "swiper"

export const Pillers = () => {
	const { isMobile } = useContext(isMobileContext)
	const { t, i18n } = useTranslation()

	const Pillers = [
		{
			icon: "/imgs/strategy/pillers/services.svg",
			title: t("Pillers.title1"),
			title_mobile: t("Pillers.title1_mobile"),
			lists: [
				t("Pillers.list1-1"),
				t("Pillers.list1-2"),
				t("Pillers.list1-3"),
				t("Pillers.list1-4"),
				t("Pillers.list1-5"),
			],
		},
		{
			icon: "/imgs/strategy/pillers/employees.svg",
			title: t("Pillers.title2"),
			title_mobile: t("Pillers.title2_mobile"),
			lists: [
				t("Pillers.list2-1"),
				t("Pillers.list2-2"),
				t("Pillers.list2-3"),
				t("Pillers.list2-4"),
				t("Pillers.list2-5"),
				t("Pillers.list2-6"),
			],
		},
		{
			icon: "/imgs/strategy/pillers/heart.svg",
			title: t("Pillers.title3"),
			title_mobile: t("Pillers.title3_mobile"),
			lists: [
				t("Pillers.list3-1"),
				t("Pillers.list3-2"),
				t("Pillers.list3-3"),
				t("Pillers.list3-4"),
				t("Pillers.list3-5"),
			],
		},
		{
			icon: "/imgs/strategy/pillers/priority.svg",
			title: t("Pillers.title4"),
			title_mobile: t("Pillers.title4_mobile"),
			lists: [
				t("Pillers.list4-1"),
				t("Pillers.list4-2"),
				t("Pillers.list4-3"),
				t("Pillers.list4-4"),
			],
		},
	]

	return (
		<div className="Pillers">
			<div className="Pillers-header">
				<div className="header-container">
					<div className="header">
						<div className="title-container">
							<motion.h2
								initial={{ opacity: 0, translateY: "100%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{
									ease: "easeInOut",
									delay: isMobile ? 0.2 : 0.2,
									duration: 0.5,
								}}
								className="title1"
							>
								{t("Pillers.headLine1")}
							</motion.h2>
						</div>
						{/* <div  
              className="title-container"
            >
             <motion.h2 
              initial={{ opacity: 0, translateY: "100%" }}
              whileInView={{ opacity: 1, translateY: 0 }}
              viewport={{ once: true }}
              transition={{ ease: "easeInOut", delay: isMobile ? 0.7 : 0.2, duration: 0.5 }} 
             className='title2'>
               {t("Pillers.headLine2-1")} 
             </motion.h2> 
            </div> */}
					</div>
				</div>
				{/* <motion.p
					initial={{ opacity: 0 }}
					whileInView={{ opacity: 1 }}
					viewport={{ once: true }}
					transition={{ ease: "easeInOut", delay: isMobile ? 0.75 : 0.5, duration: 0.5 }}
				>
					{t("Pillers.description")}
				</motion.p> */}
			</div>
			{!isMobile ? (
				<div className="Pillers-type-cards">
					{Pillers.map((item, index) => (
						<motion.div
							initial={{ opacity: 0 }}
							whileInView={{ opacity: 1 }}
							viewport={{ once: true }}
							transition={{
								ease: "easeInOut",
								delay: isMobile
									? 0.3 + parseFloat(index * 0.055)
									: 0.75 + parseFloat(index / 10),
								duration: 0.5,
							}}
							className="card"
							key={index}
						>
							<div className="icon-wrapper">
								<img
									src={process.env.PUBLIC_URL + item.icon}
									alt="Accountability"
								/>
							</div>
							<div className="card-content">
								<div className="card-title">{item.title}</div>
								<ul className="card-list">
									{item.lists.map((list, i) => (
										<li key={i}>{list}</li>
									))}
								</ul>
							</div>
						</motion.div>
					))}
				</div>
			) : (
				<>
					<div className="Pillers-type-cards">
						<Swiper
							key={`swiper-${i18n.language}`}
							// key={Math.random(0,100)}
							style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
							breakpoints={{
								0: {
									slidesPerView: 1,
									spaceBetween: 0,
								},
								767: {
									slidesPerView: 2.3,
									spaceBetween: 0,
								},
								1024: {
									slidesPerView: 2.8,
									spaceBetween: 0,
								},
								1200: {
									slidesPerView: 3,
									spaceBetween: 35,
								},
							}}
							modules={[Navigation]}
							navigation={{
								nextEl: ".media-next2",
								prevEl: ".media-prev2",
							}}
							className="media-swiper"
						>
							{Pillers.map((item, index) => (
								<SwiperSlide key={index}>
									<div className="card" key={index}>
										<div className="icon-wrapper">
											<img
												src={process.env.PUBLIC_URL + item.icon}
												alt="Accountability"
											/>
										</div>
										<div className="card-content">
											<div className="card-title">{item.title_mobile}</div>
											<ul className="card-list">
												{item.lists.map((list, i) => (
													<li key={i}>{list}</li>
												))}
											</ul>
										</div>
									</div>
								</SwiperSlide>
							))}
						</Swiper>
					</div>
					<motion.div
						initial={{ opacity: 0 }}
						whileInView={{ opacity: 1 }}
						viewport={{ once: true }}
						transition={{
							ease: "easeInOut",
							delay: isMobile ? 0.6 : 1,
							duration: 0.5,
						}}
						className="media-navigation-container"
					>
						<div className="swiper-button-prev media-prev2"></div>
						<div className="swiper-button-next media-next2"></div>
					</motion.div>
				</>
			)}
			<div className="back-layer-2">
				<img
					src={process.env.PUBLIC_URL + "/imgs/strategy/subtract.png"}
					alt=""
				/>
			</div>
			{isMobile && (
				<div className="back-layer1-mobile">
					<img
						src={process.env.PUBLIC_URL + "/imgs/home-page/vector-bg.png"}
						alt="back-layer"
					/>
				</div>
			)}
		</div>
	)
}
